import {Provider as JotaiProvider} from 'jotai';
import {RouterProvider} from 'react-router-dom';
import {ErrorBoundary} from '@app/ErrorBoundary';
import {AuthProvider} from '@app/providers/AuthProvider';
import {QueryProvider} from '@app/providers/QueryProvider';
import {ToastProvider} from '@app/providers/ToastProvider';
import {router} from '@app/router';

/**
 * Корневой компонент. Порядок провайдеров:
 *   ErrorBoundary  — перехват ошибок рендера выше всех.
 *   Jotai          — глобальный store (атомы должны быть доступны провайдерам ниже).
 *   QueryProvider  — TanStack Query.
 *   AuthProvider   — OAuth-цепочка (читает атомы и делает useQuery, поэтому ниже двух выше).
 *   RouterProvider — внутри уже доступны и атомы, и query, и контекст авторизации.
 *   ToastProvider  — Sonner portal, монтируется один раз рядом с роутером.
 */
export const App = () => (
  <ErrorBoundary>
    <JotaiProvider>
      <QueryProvider>
        <AuthProvider>
          <RouterProvider router={router} />
          <ToastProvider />
        </AuthProvider>
      </QueryProvider>
    </JotaiProvider>
  </ErrorBoundary>
);
